<template>
  <div class="stats-chart">
    <v-card
      class="chart-body"
      elevation="0"
    >
      <BarChart
        :chart-data="datacollection"
        :options="mergedOptions"
        :project-name="projectName"
        :height="380"
        downloadable
        filename="historische-preise.png"
        aria-label="Diagramm zu den historischen Energiepreisen"
      />
    </v-card>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import BarChart from '@/components/calcpreview/BarChart.vue'

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },

  options: {
    type: Object,
    required: true,
  },

  colors: {
    type: Object,
    required: true,
  },

  defaultColor: {
    type: String,
    required: true,
  },

  projectName: {
    type: String,
    default: '',
  },
})

const mergedOptions = computed(() => ({
  ...props.options,
  plugins: {
    ...props.options?.plugins,
    title: { ...props.options?.plugins?.title, text: 'Historische Preise' },
  },
}))

const datacollection = computed(() => {
  const rows = Array.isArray(props.data)
    ? props.data
    : []

  if (rows.length === 0) {
    return {
      labels: [],
      datasets: [],
    }
  }

  const chartColors = rows.map(row => {
    return props.colors[Number(row.id)] ??
      props.defaultColor
  })

  return {
    labels: rows.map(row => row.name),

    datasets: [
      {
        label: '',
        data: rows.map(row => {
          const value = Number(row.quantity)
          return Number.isFinite(value) ? value : 0
        }),

        backgroundColor: chartColors,
        borderColor: chartColors,
        borderWidth: 0,

        barPercentage: 0.5,
        maxBarThickness: 48,

        borderRadius: 6,
        borderSkipped: false,

        datalabels: {
          align: 'center',
          anchor: 'center',
        },
      },
    ],
  }
})
</script>

<style scoped lang="scss">
.stats-chart {
  width: 100%;
}

.chart-body {
  width: 100%;
  padding: 1rem;

  border: 1px solid rgba(var(--v-theme-on-surface), 0.07);
  border-radius: 22px;

  color: rgb(var(--v-theme-on-surface));
  background-color: rgba(var(--v-theme-primary), 0.02);
}

@media (max-width: 700px) {
  .chart-body {
    padding: 0.65rem;
    border-radius: 18px;
  }
}
</style>
